<template>
    <v-row no-gutters>
        <v-col cols="12">
            <!-- hierarchical navigation -->
            <v-row justify="start" class="mt-2 mx-4">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <p class="text-caption text-start">
                    <router-link :to="{ name: 'dashboard' }">Dashboard</router-link> &gt;
                    <router-link :to="{ name: 'user-account-list' }">Accounts</router-link> &gt;
                    <router-link :to="{ name: 'account-dashboard', params: { accountId: this.$route.params.accountId } }">{{ accountName }}</router-link> &gt;
                    <router-link :to="{ name: 'account-search-domain', params: { accountId: this.$route.params.accountId } }">Domains</router-link>
                </p>
                </v-col>
            </v-row>
        <v-row justify="center" class="py-5 mt-2">
            <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
            <h1 class="text-h6 font-weight-light text-center">{{ this.$route.params.domain }}</h1>
            <!-- <h1 class="text-caption font-weight-light text-center">{{ domain.status }}</h1> -->
            </v-col>
        </v-row>
        <v-row justify="center" class="py-5 px-10">
            <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <!-- <p class="text-overline mb-0">Verification code</p>
                <template v-if="!verificationCode">
                <p class="mb-0 pb-0">
                    Getting code...
                </p>
                </template>
                <template v-if="verificationCode">
                <p class="mb-0 pb-0">
                    {{ verificationCode }}
                </p>
                </template> -->
                <p class="text-overline mb-0">Domain status</p>
                <template v-if="domain && domain.status === 'verified'">
                <p class="mb-0 pb-0">
                    <font-awesome-icon :icon="['fas', 'check']" class="green--text"/>
                    Verified
                </p>
                <!-- <p class="mb-0 pb-0">
                    You can remove the DNS record.
                </p> -->
                <!-- <p class="mb-0 pb-0 mt-8">
                    <router-link :to="{ name: 'account-view-domain', params: { accountId: this.$route.params.accountId, domain: this.domain.name }}">Return to {{ domain.name }}</router-link>
                </p> -->
                </template>
                <template v-if="!domain || domain.status !== 'verified'">
                <p class="mb-0 pb-0">
                    <font-awesome-icon :icon="['fas', 'warning-triangle']" class="amber--text"/>
                    Not verified
                </p>
                </template>

                <template v-if="!verification">
                <!-- <p class="text-overline mb-0">Domain status</p> -->
                <p class="mb-0 pb-0">
                    No pending verification requests.
                </p>
                </template>

                <p class="mb-0 pb-0" v-if="(!domain || domain.status !== 'verified') && !verification">
                    <v-btn color="purple" class="white--text" @click="createVerificationCode">Start</v-btn>
                </p>

                <template v-if="verification && (verification.status === 'new' || verification.status === 'pending')">
                <!-- <p class="text-overline mb-0">Domain status</p> -->
                <!-- <p class="mb-0 pb-0">
                    There is a pending verification request.
                </p> -->
                <v-alert dense type="warning" border="left" elevation="2" class="mt-8">
                    There is a pending verification request.
                </v-alert>

                    <p class="text-overline mb-0">Directions</p>
                    <p class="mb-0 pb-0">
                        To prove ownership of the domain, you need to create the following DNS record:
                    </p>
                    <v-simple-table class="mt-8">
                        <template #default>
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Hostname</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><span class="font-weight-bold">TXT</span></td>
                                    <td><span class="font-weight-bold">_libertycloud</span><span class="font-weight-light">.{{ verification.domain }}</span></td>
                                    <td><span class="font-weight-bold">{{ verification.code }}</span></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <p class="mb-0 pb-0 mt-8">
                        GoDaddy: My Domains -&gt; DNS Management (<TextLink :href="godaddyEditDnsLink" target="_blank">direct link</TextLink>)
                    </p>

                    <template v-if="verification.not_after">
                    <p class="text-overline mb-0 mt-8">Verification code expires</p>
                    <p class="mb-0 pb-0">
                        {{ verificationCodeNotAfterDisplay }}
                    </p>
                    <p class="mb-0 pb-0">
                        If you don't successfully verify the domain by this time, reload this page to try again.
                    </p>
                    </template>
                </template>
            </v-col>
        </v-row>
        </v-col>
    </v-row>
</template>

<style scoped>

</style>

<script>
import { mapState } from 'vuex';
import { toMillis } from '@libertyio/time-util-js';
import TextLink from '@/components/TextLink.vue';

export default {
    components: {
        TextLink,
    },
    data: () => ({
        account: null,
        domain: null,
        verification: null,
        error: null,
        // verificationCode: null,
        // verificationCodeExpires: null,
        // verificationCodeNotAfter: null,
        timer: null,
    }),
    computed: {
        ...mapState({
            session: (state) => state.session,
            user: (state) => state.user,
        }),
        accountName() {
            return this.isViewReady ? this.account?.name ?? 'Unknown' : '';
        },
        isViewReady() {
            return this.account !== null;
        },
        verificationCodeNotAfterDisplay() {
            try {
                if (typeof this.verification?.not_after === 'number' && this.verification.not_after > 0) {
                    const date = new Date(this.verification.not_after);
                    return date.toString();
                }
                return 'Unknown';
            } catch (err) {
                console.log(`failed to parse verification code not-after date: ${this.verification.not_after}`);
                return 'Unknown';
            }
        },
        godaddyEditDnsLink() {
            // TODO: this is brittle, we need to monitor godaddy for changes if we're going to show this, or have a way for users to let us know it is broken
            return this.verification ? `https://dcc.godaddy.com/manage/${this.verification.domain}/dns/` : '';
        },
    },
    methods: {
        async loadAccount() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadAccount: true });
                const response = await this.$client.account(this.$route.params.accountId).currentAccount.get();
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.account = response;
                } else {
                    // TODO: redirect back to account list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load account', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadAccount: false });
            }
        },
        async loadDomain() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadDomain: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.get({ name: this.$route.params.domain });
                console.log(`domain/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.domain = response;
                }
            } catch (err) {
                if (err.response?.code === 404) {
                    console.log('domain not found');
                } else {
                    console.error('failed to load domain request', err);
                }
                this.domain = null;
                // this.error = true;
                // this.loadVerificationCode();
            } finally {
                this.$store.commit('loading', { loadDomain: false });
            }
        },
        async loadVerificationCode() {
            // NOTE: server does access control check for this, only service admin may use the function
            try {
                this.$store.commit('loading', { loadVerificationCode: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.getVerificationRequest({ domain: this.$route.params.domain });
                console.log(`loadVerificationCode: response ${JSON.stringify(response)}`);
                if (response) {
                    console.log(`loadVerificationCode: ${JSON.stringify(response)}`);
                    this.verification = response;
                    // this.status = response.status;
                    // this.verificationCode = response.code;
                    // this.verificationCodeExpires = response.expires;
                    // this.verificationCodeNotAfter = response.not_after;
                }
                if (response?.status === 'verified') {
                    this.loadDomain();
                } else {
                    console.log('loadVerificationCode: start auto-check timer');
                    this.timer = setTimeout(() => { this.checkVerification(); }, toMillis({ seconds: 15 }));
                }
            } catch (err) {
                if (err.response?.code === 404) {
                    console.log('no active domain verification request');
                } else {
                    console.error('failed to load domain verification request', err);
                }
                // this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to get verification code' });
                // this.createVerificationCode();
                this.verification = null;
            } finally {
                this.$store.commit('loading', { loadVerificationCode: false });
            }
        },
        async createVerificationCode() {
            try {
                this.$store.commit('loading', { createVerificationCode: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.createVerificationRequest({ domain: this.$route.params.domain });
                console.log(`createVerificationCode: response ${JSON.stringify(response)}`);
                if (response) {
                    this.verification = response;
                    // this.status = response.status;
                    // this.verificationCode = response.code;
                    // this.verificationCodeExpires = response.expires;
                    // this.verificationCodeNotAfter = response.not_after;
                }
                if (response?.status === 'verified') {
                    this.loadDomain();
                }
            } catch (err) {
                this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to create domain verification request' });
            } finally {
                this.$store.commit('loading', { createVerificationCode: false });
            }
        },
        async checkVerification() {
            // NOTE: server does access control check for this, only service admin may use the function
            try {
                this.$store.commit('loading', { checkVerification: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.verify({ domain: this.$route.params.domain });
                console.log(`domain/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.verification ??= {};
                    this.$set(this.verification, 'status', response.status);
                    // this.verificationCode = response.code;
                    // this.verificationCodeExpires = response.expires;
                    // this.verificationCodeNotAfter = response.not_after;
                }
                if (response?.status === 'verified') {
                    this.loadDomain();
                } else {
                    console.log('checkVerification: continue auto-check timer');
                    this.timer = setTimeout(() => { this.checkVerification(); }, toMillis({ seconds: 15 }));
                }
            } catch (err) {
                this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to check domain verification status' });
            } finally {
                this.$store.commit('loading', { checkVerification: false });
            }
        },
    },
    mounted() {
        this.loadAccount();
        this.loadDomain();
        this.loadVerificationCode();
    },
    beforeRouteLeave(to, from, next) {
        if (this.timer) {
            console.log('beforeRouteLeave: clearing timer');
            clearTimeout(this.timer);
        }
        next();
    },
};
</script>
